import { CarrierOfferList } from "../../../powerbroker/src/CarrierOfferList";
import { TrackingRequirements } from "../../../powerbroker/src/tracking/TrackingRequirements";
import { MovementOffers } from "../MovementOffers";
import { WaterfallOffers } from "../WaterfallOffers";
import { Button, DataSource, Layout, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutMovementOfferTabs extends Layout {
    buttonCancelWaterfall: Button;
    buttonOfferHistory: Button;
    buttonSkipCarrier: Button;
    layoutOfferHistory: CarrierOfferList;
    layoutPendingOffers: MovementOffers;
    layoutTracking: TrackingRequirements;
    layoutWaterfallOffers: WaterfallOffers;
    sourceMovement: DataSource;
    tabOfferHistory: Tab;
    tabPendingOffers: Tab;
    tabTracking: Tab;
    tabWaterfallProgress: Tab;
    tabsetOfferTables: Tabset;
}
